itsoftApp.createModule("filters", function () {
   var module = this;

    var init = function (filtersBlock, cb) {
        var filtersForm = filtersBlock.querySelector(".js-filters");
        var filtersWrappers = filtersBlock.querySelectorAll(".js-filter-wrapper");
        var filtersItems = filtersBlock.querySelectorAll(".js-filter-item");
        var filtersLabels = filtersBlock.querySelectorAll(".js-filter-label");

        var initFilters = function (form, filtersItem) {
            var filtersItem = filtersItem;
            var selectName = filtersItem[0].name;
            var checkedFlag = false;

            var url = "?";

            Array.prototype.forEach.call(filtersItem, function (filterItem, index) {
              var selectName = filterItem.name;

              if (filterItem.checked) {
                checkedFlag = true;
                var selectValue = filterItem.getAttribute("value");

                url += selectName + "=" + selectValue;
              }
            });

            if (!checkedFlag) {
              url = "?" + selectName + "=";
            }

            url.replace(/\s/g, '+');

            var file = form.getAttribute("action");

            // if (!file || file === "#") {
            //   file = "/ajax/publications.php";
            // }
            // 

            var query = DEBUG ? file : "./" + url;

            history.pushState("", "", url);

            cb(null, query);

            // return query;
        }

        var debouncer = itsoftApp.utils.debouncer(function () {
            initFilters(filtersForm, filtersItems);
        }, 500);

        Array.prototype.forEach.call(filtersLabels, function (filtersLabel) {
            filtersLabel.addEventListener("click", function (evt) {
              // evt.preventDefault();
              var filterItem = evt.currentTarget.closest(".js-filter-wrapper").querySelector(".js-filter-item");
              if (filterItem.checked) {
                setTimeout(function () {
                  return;
                }, 100);
              } else {
                var checkedElement = document.querySelector(".js-filter-item[checked]");

                if (checkedElement) {
                  checkedElement.removeAttribute("checked");
                }

                debouncer();
              }
            });

            filtersLabel.addEventListener("keyup", function (evt) {
              if (evt.keyCode !== 13) {
                  return;
              }

              evt.currentTarget.parentNode.querySelector("input").checked = true;

              var filterItem = evt.currentTarget.closest(".js-filter-wrapper").querySelector(".js-filter-item");

              var checkedElement = document.querySelector(".js-filter-item[checked]");

              if (checkedElement) {
                checkedElement.removeAttribute("checked");
              }

              debouncer();
            });
        });
    }

   // module.callback = initFilters;/
   module.init = init;
});